import * as React from 'react';
import AppProvider from './src/context/AppContext';
import ASGProvider from './src/context/ASGContext';
import './src/styles/arial-web-fonts.css';

export const wrapRootElement = ({ element }) => (
  <AppProvider>
    <ASGProvider>{element}</ASGProvider>
  </AppProvider>
);
